/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import Switch from "@mui/material/Switch";
import MoonLoader from "react-spinners/MoonLoader";
import Pagination from "../../../../Helper/Pagination";

export default function FooterName() {
  const [FooterNamelList, setFooterNamelList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);

  const [selectedData, setSelectedData] = useState("");

  useEffect(() => {
    getFooterNamelList();
  }, [search_key, currentPage]);

  const getFooterNamelList = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };

    PostService(API_URL.GET_FOOTER_NAME_LIST, param).then((res) => {
      if (res?.data?.status === true) {
        setFooterNamelList(res.data.data.rows);
        SetTotalPageCount(res.data.totalPages);
        SetTotalCount(res.data.totalItems);
        setCount(res.data.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  const [error, setError] = useState(false);

  const [name, setname] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    setname(selectedData?.name);
    setStatus(selectedData?.status);
  }, [selectedData]);

  const submit = (e) => {
    e.preventDefault();

    if (!name) {
      setError(true);
      return;
    }

    setsubmitLoader(true);

    let formdata = {
      id: selectedData?.footernameid,
      name,
    };

    PostService(API_URL.UPDATE_FOOTER_LIST, formdata).then(
      (res) => {
        console.log(res);
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getFooterNamelList);
          resetFunc();
          document.getElementById("closeEditModal").click();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const changeStatus = async (id, status) => {
    const data = {
      id: id,
      status: status === "active" ? "inactive" : "active",
    };

    PostService(API_URL.CHANGE_STATUS_FOOTER_LIST, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(res?.data?.message, getFooterNamelList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  function resetFunc() {
    setStatus();
    setError(false);
    setsubmitLoader(false);
  }

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3 className="default_color">Footer Names List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Footer Names List</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-4 offset-md-8 p-0">
                      <nav className="navbar">
                        <input
                          className="form-control"
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>

                  <div className="table-responsive">
                    {!loading && (
                      <table className="table table-hover text-nowrap table-striped table-bordered">
                        <thead>
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="text-center">Name</th>
                            <th className="text-center">Status</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {FooterNamelList?.map((data, i) => (
                            <tr key={i} className="text-center">
                              <td className="text-center">
                                {i + S_No_Count + 1}
                              </td>
                              <td className="text-center">{data?.name}</td>
                              <td className="text-center">
                                <span
                                  className={
                                    data?.status === "active" ||
                                    data?.status === "Active"
                                      ? "badge badge-success"
                                      : "badge badge-danger"
                                  }
                                >
                                  {data?.status}
                                </span>
                              </td>
                              <td className="text-center">
                                <span className="toggle-switch">
                                  <Switch
                                    checked={
                                      data?.status === "active" ||
                                      data?.status === "Active"
                                    }
                                    onChange={() => {
                                      changeStatus(
                                        data?.footernameid,
                                        data?.status
                                      );
                                    }}
                                    size="small"
                                    color="primary" // You can customize the color
                                    inputProps={{
                                      "aria-label": "toggle switch",
                                    }}
                                  />
                                </span>

                                {/* <Link
                                  title="View"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  to={`view/${data?._id}`}
                                >
                                  <i className="text-warning fas fa-eye"></i>
                                </Link> */}
                                <span
                                  title="Update"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setSelectedData(data);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>
                              </td>
                            </tr>
                          ))}
                          {FooterNamelList && FooterNamelList.length === 0 && (
                            <tr>
                              <td colSpan="5" className="text-center">
                                <h6 className="p-3"> No Data Found </h6>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {loading ? (
                      <div className="LoaderSpinner">
                          <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                Edit
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFunc}
              >
                {" "}
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={name}
                        onChange={(e) => setname(e?.target?.value)}
                        placeholder="Name"
                      />
                      {error && !name && (
                        <div className="error mt-1">Name is required</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
